import script from "./AllOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./AllOrders.vue?vue&type=script&setup=true&lang=js"

import "./AllOrders.vue?vue&type=style&index=0&id=7bb13fb8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bb13fb8"]])

export default __exports__